<template>
    <v-container fluid style="margin: 60px 15%">
      <vueHeadful
      :title="this.$i18n.t('Menu.Empresas') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row v-if="i">
            <v-col cols="12" align="center"  style="margin-bottom:60px">
              <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.Empresas')}}</h1>
            </v-col>
            <v-col cols="12" style="padding-bottom: 60px">
              <v-img :src="i.imagen" contain max-height="600" />
            </v-col>
            <v-col cols="12" align="center">
              <div v-html="i.textoEs" v-if="getIdioma === 'es'" />
              <div v-html="i.textoEn" v-else />
            </v-col>
          <v-col cols="12" order="3">
          <v-row>
            <v-form ref="form" v-model="valido" style="width:-webkit-fill-available!important;">
              <v-col cols="12">
                  <v-text-field v-model="nombre" :label="$t('Empresas.Nombre')" :hint="$t('Empresas.Nombre')" :rules="[v => !!v || $t('Formularios.NombreRequerido')]" solo persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-text-field v-model="email" :label="$t('Empresas.Email')" :hint="$t('Empresas.Email')" :rules="[v => !!v || $t('Formularios.EmailRequerido')]" solo persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-text-field v-model="pais" :label="$t('Empresas.Pais')" :hint="$t('Empresas.Pais')" :rules="[v => !!v || $t('Formularios.CampoRequerido')]" solo persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-text-field v-model="asunto" :label="$t('Empresas.Asunto')" :hint="$t('Empresas.Asunto')" :rules="[v => !!v || $t('Formularios.CampoRequerido')]" solo persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-textarea v-model="mensaje" :label="$t('Empresas.Mensaje')" :hint="$t('Empresas.Mensaje')" :rules="[v => !!v || $t('Formularios.CampoRequerido')]" solo persistent-hint />
              </v-col>
              <v-col cols="12" align="center">
                  <v-btn color="primary" x-large style="min-width:20%!important" @click="contacto" :disabled="!valido">{{ $t('Empresas.Enviar') }}</v-btn>
              </v-col>
            </v-form>
          </v-row>
          </v-col>
          <v-col cols="12" order="3">
          <v-row class="mt-5">
            <v-col cols="12" align="center">
                <h2 class="titulo mb-2 vietnam">{{$t('Formularios.Email')}}</h2>
                <h3 class="titulo font-weight-regular vietnam">soycliente@trartist.com</h3>
            </v-col>
            <v-col cols="12" align="center">
                <h2 class="titulo mb-2">{{$t('Formularios.TelefonoYWhatsapp')}}</h2>
                <h3 class="titulo font-weight-regular vietnam">+57 3213025754</h3>
            </v-col>
            <v-col cols="12" align="center" class="mt-2">
                <h2 class="titulo vietnam">Bogotá - Colombia</h2>
            </v-col>
        </v-row>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import axios from 'axios'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Empresas',
  mounted () {
    firebase.firestore().collection('utilidades').doc('empresas').get().then(info => {
      this.i = info.data()
    })
  },
  data () {
    return {
      infoCorreo: [],
      i: null,
      valido: false,
      nombre: null,
      email: null,
      pais: null,
      asunto: null,
      mensaje: null
    }
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    contacto () {
      axios({
        method: 'post',
        url: '/enviarcorreo',
        crossDomain: true,
        data: {
          destino: 'soycliente@trartist.com',
          asunto: this.asunto,
          texto: this.nombre + ' - ' + this.email + ' - ' + this.pais + '<br><br>' + this.mensaje
        }
      })
        .then(response => {
          this.setAlerta()
          this.setTextoAlerta(response.data)
          this.nombre = null
          this.email = null
          this.asunto = null
          this.mensaje = null
        })
        .catch(error => {
          this.setAlerta()
          this.setTextoAlerta(error)
        })
    }
  },
  computed: {
    ...mapGetters(['getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>
